import React, { useCallback, useState } from 'react';
import RenderPdfSo from './RenderPdfSo';
import TreeProcesso from './TreeProcesso';


const index = ({dataTree}) => {
  const {numero, numeroAno, itens}          = dataTree.processo;
  const [fileSelected, setFileSelected]     = useState();
  const [processandoPdf, setProcessandoPdf] = useState(false);

  const handleShowFile = useCallback((file) => {
    setFileSelected(file);
    setProcessandoPdf(true);
  }, []);

  const handleProcessandoPdf = (status) => {
    setProcessandoPdf(status);
  };

  return (
    <>
      <div className='container body-vh-full'>
        <div className='row'>
          <div className='col-3 card body-vh-full'
               style={{backgroundColor: '#303437', overflowY: 'auto', overflowX: 'hidden'}}>
            <TreeProcesso numero={numero}
                          itens={itens}
                          handleShowFile={handleShowFile}
                          processandoPdf={processandoPdf} />
          </div>
          <div className='col-9 p-0 card body-vh-full overflow-auto'>
            <RenderPdfSo numeroAno={numeroAno} file={fileSelected} handleProcessandoPdf={handleProcessandoPdf} />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
